import styled from "@emotion/styled";
import { graphql, StaticQuery } from "gatsby";
import React from "react";
import SpacerComponent from "../contents/spacer";
import { BlockRow, Row } from '../grid/grid.component';
import ProductCard from './product-card.component';

class ProductGrid extends React.Component {

  constructor() {
    super()

    this.state = {
      category: '',
      casestudy: ''
    }

    this.setCategory = this.setCategory.bind(this);
  }

  shouldComponentUpdate(nextProps, nextState) {

    const { transitionStatus, entry, exit } = nextProps;
    console.log('- Render Product Grid (shouldComponentUpdate)', nextProps.transitionStatus);

    return transitionStatus.indexOf('exit') < 0;
  }

  filterProducts(products, category) {
    if (category === '') {
      return products;
    }
    return products.filter(product => (product.data.category.document[0].data.name_plural === category))
  }
  setCategory(category) {
    this.setState({ category: category })
  }
  setCaseStudy(casestudy) {
    this.setState({ casestudy: casestudy })
  }
  render() {
    console.log('- Render Product Grid', this.props.transitionStatus);
    return (
      <StaticQuery
        query={graphql`
        query { 
          allPrismicCategory {
            nodes {
              id
              data {
                name_plural
              }
            }
          }
          allPrismicCases {
            nodes {
              id
              data {
                title {
                  html
                  text
                }
              }
            }
          }
          allPrismicProduct {
              nodes {
                id
                uid
                lang
                data{
                  
                  title{
                    text
                  }
                  case {
                    id
                    uid
                  }
                  card_size
                  card_image {
                    ...prismicProductDataCardImageFragment
                    Wide{
                      ...prismicProductDataCardImageWideFragment
                    }
                  }
    
                  mainimage {
                    ...prismicProductDataMainimageFragment
                  }
                  category {
                    id
                    document {
                      prismicId
                      data{
                        name_plural
                      }
                    }
                  }
                }
              }
          }
        }
        `
        }
        render={data => {

          const { allPrismicProduct, allPrismicCategory, allPrismicCases } = data;
          const { primary } = this.props;
          // console.log('allPrismicProduct', nodes);


          //let normals = nodes.filter(product => { return product.data.card_size === 'wide' });

          const orderedProducts = this.filterProducts(allPrismicProduct.nodes, this.state.category);//orderGrid(normals);
          return (
            <div>
              <Row>
                <Filter className="default-fade">
                  <div className="filter-button text">{primary.filter_text} +</div>
                  <div className="filter-options">
                    <div className={`text label`}>{primary.category_text}</div>
                    <div onClick={() => this.setCategory('')} className={`text button ${this.state.category === '' ? 'active' : ''}`}><div>All</div></div>
                    {allPrismicCategory.nodes.map(category => (
                      <div key={category.id} className={`text button ${this.state.category === category.data.name_plural ? 'active' : ''}`} onClick={() => this.setCategory(category.data.name_plural)}><div>{category.data.name_plural}</div></div>
                    ))}
                  </div>
                  <div className="filter-options">
                    <div className={`text label`}>{primary.case_study_text}</div>
                    <div onClick={() => this.setCaseStudy('')} className={`text button ${this.state.category === '' ? 'active' : ''}`}><div>All</div></div>
                    {allPrismicCases.nodes.map(category => (
                      <div key={category.id} className={`text button ${this.state.category === category.data.title.text ? 'active' : ''}`} onClick={() => this.setCaseStudy(category.data.title.text)}><div>{category.data.title.text}</div></div>
                    ))}
                  </div>
                </Filter>
              </Row>
              <SpacerComponent />
              <BlockRow>
                <Products>
                  {orderedProducts.map(product => {
                    return (
                      <ProductCard key={product.id} {...product.data} transitionStatus={this.props.transitionStatus} size={product.size} productcase={product.data.case} uid={product.uid} />
                    )
                  }
                  )}

                </Products>
              </BlockRow>
            </div>
          )
        }}
      />
    )
  }
}


export default ProductGrid


const Filter = styled.div`
  width: 80%;
  margin: 0 auto;
  position: relative;
  .text{
    font-size: 12px;
    letter-spacing: .35em;
    text-transform: uppercase;
    text-align: center;
    padding: 10px 10px;
  }

  .filter-button{
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    transition: all 200ms;
  }
  .filter-options{
    opacity: 0;
    transform: translateX(-10px);
    transition: transform 500ms, opacity 100ms;
    display: flex;
    width: 70%;
    margin-left: auto;

    & > div{
      display: inline-block;
      &.label{
        opacity: .5;
        min-width: 160px;
        text-align: left;
      }
      &.button{
        cursor: pointer;
        margin-right: 20px;
      }
      & > div{
        display: inline-block;
      }
      &.button:hover, &.active{
        & > div:after{
          content: "";
          display: block;
          border-bottom: 1px solid black;
          width: 95%;
          margin-top: 5px;
        }
      }
    }
  }

  &:hover{
    .filter-button{
      left: 0;
      transform: translateX(0%);
    }
    .filter-options{
      opacity: 1;
      transform: translateX(0px);
    }
  }

`



const Products = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  /* justify-content: center; */
  flex-wrap: wrap;
  /* min-height: 100vh; */
  margin: 0 -24px;
  min-width: 100%;
  
`